import { FC } from "react";
import { TableCell, TableHeadCell } from "@rothoblaas/design-system";
import AdminCrudTable from "../../../../components/ui/AdminCrudTable";
import useI18n from "../../../../hooks/useTranslations";
import { LoadDurationClass } from "../../../../http/screwConnector/types/normativeTables";
import { useScrewConnectorLoadDurationClassesApi } from "../../../../http/screwConnector/useAdminNormativeTables";
import LoadDurationClassForm from "./LoadDurationClassForm";

const AdminLoadDurationClasses: FC = () => {
  const i18n = useI18n();
  const t = i18n.translation.screwConnectorModule.normativeTables.loadDurationClasses;
  const api = useScrewConnectorLoadDurationClassesApi();

  return (
    <AdminCrudTable<LoadDurationClass>
      filterPrefix="load_duration_classes"
      useList={api.useLoadDurationClasses}
      head={
        <>
          <TableHeadCell align="left">{t.fields.code}</TableHeadCell>
          <TableHeadCell align="left">{t.fields.name}</TableHeadCell>
        </>
      }
      renderRow={(item) => (
        <>
          <TableCell>{item.code}</TableCell>
          <TableCell>{item.name}</TableCell>
        </>
      )}
      updateOrder={(item, order) =>
        api.updateLoadDurationClass(item.code, {
          name: item.name,
          nameIt: item.nameIt,
          nameDe: item.nameDe,
          nameEs: item.nameEs,
          nameFr: item.nameFr,
          order,
        })
      }
      onDelete={(item) => api.deleteLoadDurationClass(item.code)}
      deleteTitle={t.singular}
      canAdd
      renderForm={(item, onClose) => <LoadDurationClassForm loadDurationClass={item} onClose={onClose} />}
    />
  );
};

export default AdminLoadDurationClasses;
